export const enterpriseMenuData = [
  {
    id: 1,
    url: "/blog",
    title: "Blog",
  },
  {
    id: 2,
    url: "/events",
    title: "Events",
  },
  // {
  //   id: 3,
  //   url: "/mc",
  //   title: "Masterclass",
  // },
  {
    id: 4,
    url: "/corporate-training",
    title: "Consulting practice",
  },
  {
    id: 5,
    url: "/scholarship",
    title: "Scholarships",
  },
  {
    id: 6,
    url: "/podcast",
    title: "Podcast",
  },
];

export const growData = [
  {
    id: 1,
    url: "/business",
    title: "Business",
  },
  {
    id: 2,
    url: "/impact",
    title: "Utiva Impact",
  },
  // {
  //   id: 3,
  //   url: "/kids",
  //   title: "Utiva Kids",
  // },
  {
    id: 4,
    url: "/nucleus",
    title: "The Nucleus",
  },
  {
    id: 5,
    url: "/mba",
    title: "Global MBA",
  },
];

export const learnBusinessData = [
  {
    id: 1,
    url: "https://study.utiva.co/",
    title: "Enrol Your Staff",
    desc: "Place your team in an existing live Utiva course.",
  },
  {
    id: 2,
    url: "/business",
    title: "Custom Training",
    desc: "Build a focused academy around your organisation's capability gaps.",
  },
  {
    id: 3,
    url: "/hire",
    title: "Utiva Hire and Pay",
    desc: "Find verified talent, onboard teams and support global payments.",
  },
];
